import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronRightIcon, XIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { categories } from '../../data/collections';
import { Logo } from '../brand/Logo';
const ease = [0.23, 1, 0.32, 1] as const;
export function MobileMenu({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-230" data-mp="1ja5gnzzqezbw">
      {open && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-231" data-mp="1j92s3ypvt8z5">
          <motion.div className="absolute inset-0 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-232" data-mp="vkjinfv3iq5h" />
          <motion.aside role="dialog" aria-modal="true" aria-label="Menu" className="absolute inset-y-0 left-0 flex w-[86%] max-w-sm flex-col overflow-y-auto bg-canvas" initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        duration: 0.25,
        ease
      }} data-id="element-233" data-mp="494o2lqokpt">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-234" data-mp="3deq0pqt3jg9b">
              <Logo size="sm" data-id="element-235" data-mp="3ici1797t4ap4" />
              <button onClick={onClose} className="grid h-10 w-10 place-items-center rounded-full" aria-label="Menu sluiten" data-id="element-236" data-mp="3mdjt14ze9kh2">
                <XIcon className="h-5 w-5" data-id="element-237" data-mp="3rd69dnairgu3" />
              </button>
            </div>
            <ul className="px-5 py-3" data-id="element-238" data-mp="11nkz3zf6pbxg">
              {mainNav.map(item => <li key={item.to} data-id="element-239" data-mp="11pozw8hsduti">
                  <Link to={item.to} onClick={onClose} className="flex items-center justify-between border-b border-line py-4 text-lg font-medium" data-id="element-240" data-mp="16lmjcnocjhai">
                    {item.label}
                    <ChevronRightIcon className="h-4 w-4 text-muted" data-id="element-241" data-mp="2yo8oeosc1jpq" />
                  </Link>
                </li>)}
            </ul>
            <p className="px-5 pt-4 text-xs font-medium text-muted" data-id="element-242" data-mp="3cn82x3m4si86">Per categorie</p>
            <ul className="flex flex-wrap gap-2 px-5 py-3" data-id="element-243" data-mp="37pompy5vhvdl">
              {categories.map(c => <li key={c.id} data-id="element-244" data-mp="2jzuczpguomxk">
                  <Link to={`/collectie/${c.id}`} onClick={onClose} className="block rounded-full border border-line px-3.5 py-1.5 text-sm" data-id="element-245" data-mp="2jwzvo6t4vi8d">
                    {c.title}
                  </Link>
                </li>)}
            </ul>
            <Link to="/over-amira" onClick={onClose} className="mt-auto border-t border-line px-5 py-5 text-sm text-muted" data-id="element-246" data-mp="2oxvu44upuc6e">
              Over Amira
            </Link>
          </motion.aside>
        </div>}
    </AnimatePresence>;
}